import plugin from './src/resize-observer.plugin.js';
export default plugin;